import React from 'react';
import { selectableDrawTypeOptions } from 'js/config/animationOptions';

import { useAnimationStageContext } from './AnimationStageContext';
import { AnimationStagePanelOptionsGrid } from './AnimationStageConfigurationOptions';
import OptionMenuButton, { OptionMenuButtonIconAndText } from './OptionMenuButton';

const DrawTypeMenu = () => {
  const { currentSelectedDrawType, onDrawTypeChoice } = useAnimationStageContext();

  return (
    <AnimationStagePanelOptionsGrid>
      {selectableDrawTypeOptions.map(option => {
        return (
          <OptionMenuButton
            selected={currentSelectedDrawType === option.value}
            key={option.id}
            onClick={() => onDrawTypeChoice(option.value)}
          >
            <OptionMenuButtonIconAndText icon={<option.Icon />}>{option.label}</OptionMenuButtonIconAndText>
          </OptionMenuButton>
        );
      })}
    </AnimationStagePanelOptionsGrid>
  );
};

export default DrawTypeMenu;
